import { I18n } from '@byted-cg/linkchat-plugin';
// Judgment type
export const is = {
  array(data: unknown): boolean {
    return Array.isArray(data);
  },
  object(data: unknown): boolean {
    return Object.prototype.toString.call(data) === '[object Object]';
  },
  map(data: unknown): boolean {
    return Object.prototype.toString.call(data) === '[object Map]';
  },
  func(data: unknown): boolean {
    return Object.prototype.toString.call(data) === '[object Function]';
  },
  file(data: unknown): boolean {
    return Object.prototype.toString.call(data) === '[object File]';
  },
  fileList(data: unknown): boolean {
    return Object.prototype.toString.call(data) === '[object FileList]';
  },
  empty(data: unknown): boolean {
    return (
      typeof data === 'undefined' ||
      Object.prototype.toString.call(data) === '[object Null]'
    );
  },
  emptyObject(data: { [key: string]: unknown }): boolean {
    return Object.keys(data).length === 0;
  },
  isPromiseLike(data: any) {
    return (
      data !== null &&
      (typeof data === 'object' || typeof data === 'function') &&
      typeof data?.then === 'function'
    );
  },
};

export function parseQueryString() {
  const search = window.location.search;
  if (!search) return {};
  const obj: Record<string, string> = {};
  const paraString = search
    .substring(search.indexOf('?') + 1, search.length)
    .split('&');
  for (const i in paraString) {
    const keyvalue = paraString[i].split('=');
    obj[keyvalue[0]] = keyvalue[1];
  }
  return obj;
}

const getBase64 = (file: File): Promise<any> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      const image = new Image();
      image.src = reader.result as string;
      image.onload = () => {
        resolve(
          {
            name: file.name,
            src: reader.result,
            height: `${image.height}`,
            width: `${image.width}`,
          } || null,
        );
      };
      image.onerror = () => {
        reject(I18n.t('image_type_is_wrong_', {}, '图片类型有误'));
      };
    });
    reader.addEventListener('error', (e) => {
      reject(e);
    });
    reader.readAsDataURL(file);
  });
};

const round = (num: number, deep: number) => {
  return Math.round(num * deep) / deep;
};

const handleSize = (size: number | string) => {
  let result = '';
  size = Number(size);
  if (size < 1000 * 1000) {
    // Byte = > k
    result = round(size / 1000, 100) + 'K';
  } else {
    // Byte = > m
    result = round(size / (1000 * 1000), 100) + 'M';
  }
  return result;
};

export const filterPic = async (
  arr: Array<
    File & {
      status?: number;
      tempUrl?: string;
      showSize: string;
      imageSize: Record<string, string>;
      errorMessage?: string;
      height: number | string | undefined;
      width: number | string | undefined;
      ext: string;
      subType: string;
      invokeSrc?: string;
      getIcon?: any;
    }
  >,
) => {
  let tmp = [];
  for (let i = 0; i < arr.length; i++) {
    let file = arr[i];
    try {
      let { src: url, width, height } = await getBase64(file);
      file.status = 1;
      file.tempUrl = url;
      file.showSize = handleSize(file.size);
      file.imageSize = { width, height };

      // Limit the volume
      if (file.size > 1024 * 1024 * 300) {
        file.status = 0;
        file.errorMessage = I18n.t(
          'sending_pictures_supports_a_maximum_of_300m__exceeding_the_limit!',
          {},
          '发送图片最大支持300M，超出限制！',
        );
      }

      tmp.push(file);
    } catch (e) {
      file.status = 0;
      file.errorMessage = I18n.t('image_loading_failed', {}, '图片加载失败');
      tmp.push(file);
    }
  }
  return tmp;
};

export const getImageWH = (
  file: File,
): Promise<{
  name: string;
  src?: string;
  height?: number;
  width?: number;
  instance: File;
  isError?: boolean;
}> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      const image: any = new Image();
      image.src = reader.result;
      image.onload = () => {
        resolve({
          name: file.name,
          src: reader.result as string,
          height: image.height,
          width: image.width,
          instance: file,
        });
      };
      image.onerror = () => {
        resolve({
          name: file.name,
          instance: file,
          isError: true,
        });
      };
    });
    reader.readAsDataURL(file);
  });
};

export const getVideoWH = (
  file: File,
): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.src = URL.createObjectURL(file);

    const timer = setTimeout(() => {
      reject(new Error(I18n.t('loading_video_timed_out', {}, '加载视频超时')));
    }, 1000);

    video.addEventListener('loadeddata', function () {
      window.URL.revokeObjectURL(video.src);
      clearTimeout(timer);
      resolve({
        height: video.videoHeight,
        width: video.videoWidth,
      });
    });

    video.addEventListener('error', function () {
      window.URL.revokeObjectURL(video.src);
      clearTimeout(timer);
      reject(new Error(I18n.t('error_loading_video', {}, '加载视频出错')));
    });
  });
};

export const isLark = () => {
  const agent = navigator.userAgent;
  const inLark = agent.match(/(Lark)\/([\d.]+)/);
  return !!inLark;
};
